import React from "react";
import tryFetchingGeminiAIResponse from "../../others/geminiAI";

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
  const handleUserMessage = async (message) => {
    // Show typing effect (blank or a placeholder message with a delay)
    const typingMessage = createChatBotMessage("Typing...", {
      delay: 0, // Delay before this "typing" message appears
      withAvatar: true,
    });

    // Add the typing message to the state
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, typingMessage],
    }));

    // Simulate asynchronous operation (like an API call)

    // Custom action logic
    const { text, originalMessage } = message;

    // Example: Log the original message and text
    const response = await tryFetchingGeminiAIResponse(text);

    // Create and send the actual chatbot message once the response is available
    const botMessage = createChatBotMessage(response);

    // Update the state by replacing the typing message with the actual bot message
    setState((prev) => ({
      ...prev,
      messages: [
        ...prev.messages.slice(0, -1), // Remove the last "typing" message
        botMessage,
      ],
    }));
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
            handleUserMessage,
          },
        });
      })}
    </div>
  );
};

export default ActionProvider;
